// extracted by mini-css-extract-plugin
export default {"label":"styles_label__RXHtd","container":"styles_container__jkXqE","group":"styles_group__w0kwU"};